import React from 'react';

const OpenCodeEditor = () => {
	const questionId = '';
	const endpoint = 'https://api.acciojob.com';
	const platform = 'open';
	const type = 'course';
	const contestId = '';
	const hostingPlatform = 'https://ide.acciojob.com';

	return (
		<iframe
			className={'CodeEditor'}
			allow={'fullscreen'}
			src={`${hostingPlatform}/?question=${questionId}&endpoint=${endpoint}&platform=${platform}&type=${type}&contest=${contestId}`}
		/>
	);
};

export default OpenCodeEditor;
